// Acciones para la EDICIÓN DE SUPERVISIÓN de un traslado (perfil supervisor).
// Pega al endpoint REAL del microservicio: PUT /api/v1/orden-servicio/traslados/{idTraslado}
// (plural). Devuelve el traslado actualizado con su historial_cambios.
import { urlBackend } from "@/shared/constants";
import { erpApi } from "@/shared/axios";

const { put } = erpApi();

/** Payload de edición (todos opcionales: solo se envía lo que cambia el form). */
export type TrasladoSupervisionUpdate = {
  direccion?: string;
  coordenada?: string;
  valor_traslado?: string;
  recaudacion_tecnico?: boolean;
  cargo_a_factura?: boolean;
  meses_pago?: number | null;
  observaciones?: string;
  flota?: string;
  fecha_traslado?: string | null; // ISO LocalDateTime
  puntos_antes_canje?: number | null;
  puntos_canjeados?: number | null;
  parroquia?: string;
  zona?: string;
  sector?: string;
};

export const putTrasladoSupervision = async (
  idTraslado: string,
  data: TrasladoSupervisionUpdate,
) => {
  return put<any>(`${urlBackend}api/v1/orden-servicio/traslados/${idTraslado}`, data, true);
};
